export default "__VITE_ASSET__3e5e72a0__"